export const Config = {
  displayKeywods: false,
};
